import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Table from './table';

const NpoRegions = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  useEffect(() => {
    if (user?.permissions?.npo_regions?.add_edit) {
      setCanUpdate(true);
    }
    if (user?.permissions?.npo_regions?.delete) {
      setCanDelete(true);
    }
  }, [user]);

  return (
    <div className='page-top-div'>
      <span className='text-span'>NPO Regions Manager</span>
      <Table canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default NpoRegions;
